import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const AdminBarContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({theme}) => theme.colors.black};
  padding: 0px 10px;
  color: ${({theme}) => theme.colors.white};
  margin-bottom: 0.2rem;
`

export const SearchSection = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 0;
`

export const ButtonLink = styled(Link)`
  background-color: #6b6b6b;
  color: #ffffff;
  text-decoration: none;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  cursor: pointer;

${({ theme }) => theme.mediaQueries.phoneOnly} {
padding: 2px 8px; 
}
`
